import gql from 'graphql-tag';

export const AUTH_QUERY = gql`{
  authentication {
    email
    isVerified
    isAuthenticated
  }
  contact {
    id
    firstName
    lastName
  }
}`;


export const AUTH_QUERY_LOGIN = gql`{
  authentication {
    email
    isAdmin
    isAuthenticated
    isVerified
    tokenExpire
  }
}`;